


























































































































































































































import { defineComponent, onBeforeMount, reactive } from '@vue/composition-api'

import { ChainStoreState, ReceiptState, UserState } from '@/types/store'
import { receiptSuppliers, genders } from '@/types/receipt'
import { ChainStore } from '@/types/shop'
import useVuex from '@/utils/useVuex'
import { ngReasons } from '@/utils/ngReasons'

import { AppAutocomplete } from '@/components/atoms'
import Layout from '@/components/organisms/common/Layout.vue'
import { ReceiptsTable } from '@/components/organisms/system-ng-receipts'

export default defineComponent({
  name: 'SystemNgReceipts',
  components: { Layout, ReceiptsTable, AppAutocomplete },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      receipts: useVuex<ReceiptState['receipts']>(
        context,
        () => store.getters['receipt/receipts'],
      ),
      total: useVuex<ReceiptState['total']>(
        context,
        () => store.getters['receipt/total'],
      ),
      isReceiptsLoading: useVuex<ReceiptState['isReceiptsLoading']>(
        context,
        () => store.getters['receipt/isReceiptsLoading'],
      ),
      chainStores: useVuex<ChainStoreState['chainStores']>(
        context,
        () => store.getters['chainStore/chainStores'],
      ),
      searchCondition: useVuex<ReceiptState['searchCondition']>(
        context,
        () => store.getters['receipt/searchCondition'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      isContributedAtStartOpen: false,
      isContributedAtEndOpen: false,
      isPurchasedAtStartOpen: false,
      isPurchasedAtEndOpen: false,
    })

    onBeforeMount(() => {
      store.dispatch('receipt/resetReceipts')
    })

    const onSelectChainStore = (cs?: ChainStore) => {
      if (cs === undefined) {
        state.searchCondition.chainStoreName = null
        return
      }
      state.searchCondition.chainStoreName = cs.name
    }

    const search = async () => {
      try {
        await store.dispatch('receipt/getSystemNgReceipts', {
          supplier: state.searchCondition.supplier,
          monitorId: state.searchCondition.monitorId,
          receiptId: state.searchCondition.receiptId,
          contributedAtStart: state.searchCondition.contributedAtStart,
          contributedAtEnd: state.searchCondition.contributedAtEnd,
          gender: state.searchCondition.gender,
          age: state.searchCondition.age,
          prefecture: state.searchCondition.prefecture,
          chainStoreName: state.searchCondition.chainStoreName,
          purchasedAtStart: state.searchCondition.purchasedAtStart,
          purchasedAtEnd: state.searchCondition.purchasedAtEnd,
          ngReason: state.searchCondition.ngReason,
        })
      } catch (_error) {
        await store.dispatch('receipt/setReceipts', [])
        alert('タイムアウトしました。検索条件を変更して再度お試しください。')
      }
    }

    return {
      state,
      onSelectChainStore,
      search,
      receiptSuppliers,
      genders,
      ngReasons,
    }
  },
})
